import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=template&id=0623a012&lang=html"
import script from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso5HerancaConfig.vue?vue&type=style&index=0&id=0623a012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports